
export function escapedRegExp (str) {
  return new RegExp(str.replace(/[\u0300-\u036f]/g, '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
}

export function generateRandomString (length) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export function getHashParams () {
  let hashParams = {}
  let r = /([^&;=]+)=?([^&;]*)/g
  let q = window.location.hash.substring(1)
  let e = r.exec(q)
  while (e) {
    hashParams[e[1]] = decodeURIComponent(e[2])
    e = r.exec(q)
  }
  return hashParams
}

export function padString (string) {
  string = string + ''
  let pad = '00'
  return pad.substring(0, 2 - string.length) + string
}

export function msToTime (s) {
  var ms = s % 1000
  s = (s - ms) / 1000
  var secs = s % 60
  s = (s - secs) / 60
  var mins = s % 60
  return mins + ':' + padString(secs)
}

export function copyTextToClipboard (text, isMobile) {
  var textArea = document.createElement('textarea');

  //
  // *** This styling is an extra step which is likely not required. ***
  //
  // Why is it here? To ensure:
  // 1. the element is able to have focus and selection.
  // 2. if element was to flash render it has minimal visual impact.
  // 3. less flakyness with selection and copying which **might** occur if
  //    the textarea element is not visible.
  //
  // The likelihood is the element won't even render, not even a flash,
  // so some of these are just precautions. However in IE the element
  // is visible whilst the popup box asking the user for permission for
  // the web page to copy to the clipboard.
  //

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  // textArea.style.width = '2em'
  // textArea.style.height = '2em'

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0

  // Clean up any borders.
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent'

  textArea.value = text
  document.body.appendChild(textArea)

  // alert(textArea)
  if (isMobile) {
    let range = document.createRange()
    range.selectNodeContents(textArea)
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
    textArea.setSelectionRange(0, 99999999)
  } else {
    textArea.focus()
    textArea.select()
  }

  var result = true
  try {
    document.execCommand('copy')
    textArea.blur()
  } catch (err) {
    result = false
    console.log(err)
  }

  document.body.removeChild(textArea)

  return result
}


// WEBPACK FOOTER //
// ./src/core/Utils.js